import { render, staticRenderFns } from "./ChipsBlock.vue?vue&type=template&id=8fe4e90a"
import script from "./ChipsBlock.vue?vue&type=script&lang=js"
export * from "./ChipsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports